import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Card, CardBody, Col, FormGroup, Input, Label, Row } from 'reactstrap'
import { getUserStart } from '../../../store/SuperAdmin/Authentication/Users/action';
import Spinners from 'components/Common/Spinner';
import { sendWhatsAppMsg } from 'store/actions';
import { toast } from 'react-toastify';

const SendWhatsAppMsg = () => {
    const dispatch = useDispatch();

    const [message, setMessage] = useState("")
    const { loading: userLoading, userDetails } = useSelector(state => state.SuperUser)
    const { Loading, successMsg, errors } = useSelector(state => state.sendWhatsAppMsgReducer)


    const [selectedUsers, setSelectedUsers] = useState([]);

    useEffect(() => {
        console.log("Selected Users:", selectedUsers);
    }, [selectedUsers]);

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allUserIds = userDetails?.data?.map(user => String(user.id)) || [];
            setSelectedUsers(allUserIds);
        } else {
            setSelectedUsers([]);
        }
    };

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        console.log(`Checkbox ${value} changed to ${checked}`);
        if (checked) {
            setSelectedUsers(prev => [...prev, value]);
        } else {
            setSelectedUsers(prev => prev.filter(id => id !== value));
        }
    };

    const handleSendWhatsAppMsg = () =>{
        if(message){
            if(selectedUsers.length > 0){

                dispatch(sendWhatsAppMsg({"id":selectedUsers, "message":message}))
            }else{
                toast.warning("Please Select Users")
            }
        }else{
            toast.warning("Please Type Message")
        }
    }

    useEffect(() => {
        if (errors && errors !== "") {
            toast.error(errors)
        }
        if (successMsg && successMsg !== "") {
            toast.success(successMsg)
        }
    }, [errors, successMsg])


    useEffect(() => {
        dispatch(getUserStart())
    }, [dispatch])
    return (
        <div className='page-content'>
            <h4>Send WhatsApp Message</h4><hr />
            {
                Loading ? <Spinners />
                    :

                    <Row>
                        <Col md={4}>
                        <h6>Type Message</h6>
                            <Input type='textarea' placeholder='Type Message Here' value={message} style={{ height: "70vh" }} onChange={(e) => setMessage(e.target.value)} />
                        </Col>
                        <Col md={4} >
                        <h6>Preview Message</h6>
                            <Card style={{ height: "70vh" }}>
                                <CardBody className='h-100'>
                                    <p>Hello (user name),</p>
                                    <p>{message}</p>
                                    <p className='position-absolute bottom-0 end-0 m-2'>Your, Technology Partener, <br /> Wwings Smart Technologies</p>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={4} >
                        <h6>Send Message</h6>
                            <div className='bg-white shadow p-1'>
                                {userLoading ? <Spinners /> :
                                    <>

                                        <FormGroup check style={{ maxHeight: "62vh", overflowY: "scroll" }}>

                                            <Label check>
                                                <Input
                                                    type="checkbox"
                                                    value="*"
                                                    onChange={handleSelectAll}
                                                    checked={userDetails?.data?.length > 0 && selectedUsers.length === userDetails.data.length}
                                                />{' '}
                                                SELECT ALL
                                            </Label>
                                            <br />
                                            {userDetails?.data && userDetails.data.map((user, index) => (
                                                <React.Fragment key={user.id}>
                                                    <Label check>
                                                        <Input
                                                            type="checkbox"
                                                            value={String(user.id)}
                                                            onChange={handleCheckboxChange}
                                                            checked={selectedUsers.includes(String(user.id))}
                                                        />{' '}
                                                        {user.name}
                                                    </Label>
                                                    <br />
                                                </React.Fragment>
                                            ))}
                                        </FormGroup>


                                        <Button className='mt-3' color='primary' onClick={handleSendWhatsAppMsg}>Send Message</Button>
                                    </>}
                            </div>
                        </Col>
                    </Row>
            }
        </div >
    )
}

export default SendWhatsAppMsg